import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import logoThree from "../../../assets/images/logo/Haylo-logo-white.png";
import "../Microsite/style/microsite-one.css";
import "../Microsite/style/style.css";
import "./qrStyle.css";
import { baseURLPublic } from "../../../config/BaseUrl";
import moment from "moment";
import CountDownSimple from "../../../components/CountDown/CountDown";
import { LoadingSpinner } from "../../../components/Loader/Loader";

function Avail() {
  const { eventId, uuid, voucherNo } = useParams();
  const [qrCode, setQrCode] = useState("");
  const [claimMessage, setClaimMessage] = useState("");
  const [pageLoader, setPageLoader] = useState(false);
  const [claim, setClaim] = useState(false);

  useEffect(() => {
    setPageLoader(true);
    baseURLPublic
      .get(`offer/avail/${eventId}/qr-code/${uuid}/voucher_no/${voucherNo}`)
      .then((res) => {
        if (res.data) {
          setQrCode(res.data.qr_code_details);
          setPageLoader(false);
        }
      });
    return () => {
      setPageLoader(false);
    };
  }, [claim, eventId, uuid, voucherNo]);

  const ClaimedOffer = () => {
    try {
      baseURLPublic
        .post(`offer/claim/qr-code/${qrCode && qrCode.voucher_id}`)
        .then((res) => {
          if (res.data) {
            setClaimMessage("Voucher claimed successfully");
          }
        });
    } catch (error) {
      console.log(error);
    }
  };

  const expireDate = Math.floor(
    new Date(qrCode && qrCode.expire_in).getTime() / 1000
  );
  const currentDate = Math.floor(new Date().getTime() / 1000);

  return (
    <div className="Customer-microsite-default">
      <div className="header default-header">
        <div className="container">
          <div className="row">
            <div className="col">
              <div className="header-image text-center py-4 mb-4">
                <img
                  src={logoThree}
                  className="img-fluid"
                  alt="logo"
                  style={{ width: "250px" }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="main-body offer-main-body">
        <div className="container">
          <div className="row justify-content-center">
            {pageLoader ? (
              <div className="col-md-12">
                <div className="topTitleLoader text-center">
                  <div className="spinner-grow text-white" role="status">
                    <span className="sr-only">Loading...</span>
                  </div>
                </div>
              </div>
            ) : (
              <>
                <div className="col-md-12">
                  {claimMessage && (
                    <div className="alert alert-success alert-dismissible claimMessage">
                      <button
                        type="button"
                        onClick={() => setClaimMessage("")}
                        className="close"
                        data-dismiss="alert"
                      >
                        &times;
                      </button>
                      <strong>{claimMessage}</strong>
                    </div>
                  )}
                </div>
                <div className="col-md-12">
                  <div className="offer-stage">
                    <div className="topTitle">
                      <h2 className="offer-title">OFFER: {qrCode.offer_name}</h2>
                      <p className="offer-subtitle">Show this at the bar &amp; enjoy!</p>
                      <div className="offer-expiry">
                        {qrCode && qrCode?.is_used === 1 ? (
                          ""
                        ) : (
                          <span className="offer-expiry-label">EXPIRES:</span>
                        )}
                        {qrCode && qrCode?.is_used === 1 ? (
                          <span className="VoucherStatusText">Claimed</span>
                        ) : expireDate > currentDate ? (
                          <CountDownSimple
                            timeTillDate={
                              qrCode &&
                              moment(qrCode && qrCode?.expire_in).format(
                                "MM DD YYYY, HH:mm:ss"
                              )
                            }
                            timeFormat="MM DD YYYY, HH:mm:ss"
                          />
                        ) : (
                          <span className="VoucherStatusText">Expired</span>
                        )}
                      </div>
                    </div>
                    {qrCode && qrCode?.is_used === 1 ? (
                      ""
                    ) : (
                      <div className="qrCard">
                        <div className="qrCard-body">
                          <>
                            <div className="red-thick-line" />
                            <p className="staff-only">FOR STAFF USE ONLY</p>
                          </>
                          {expireDate > currentDate ? (
                            <>
                              <button
                                type="button"
                                onClick={() => {
                                  ClaimedOffer();
                                  setClaim(true);
                                }}
                                className="btn btn-primary mt-3 btn-sm offer-claim-btn"
                              // disabled={
                              //   qrCode && qrCode?.is_used === 1
                              //     ? true
                              //     : expireDate > currentDate
                              //     ? false
                              //     : true
                              // }
                              >
                                {claim === true ? (
                                  <LoadingSpinner
                                    color="text-white"
                                    className="spinner-grow-sm"
                                  />
                                ) : (
                                  "CLAIM"
                                )}
                              </button>
                            </>
                          ) : (
                            ""
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </div>

      <div className="micro-site-footer">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <p className="text-center footer-name mb-0 py-4">
                Brought you by{" "}
                <Link to="#" style={{ color: "#fff" }}>
                  The Haylo
                </Link>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Avail;
